var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"accommodationsearchEmbed mb-3 px-1 pt-1",attrs:{"color":"info","outlined":""}},[_c('minimum-filter',{attrs:{"horizontal":""},on:{"update":_vm.searchAccommodations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }